import { render, staticRenderFns } from "./TransporterBidButton.vue?vue&type=template&id=8fd15a68"
import script from "./TransporterBidButton.vue?vue&type=script&lang=js"
export * from "./TransporterBidButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports